/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

const INDIVIDUAL_USER_ORG_PREFIX = "_ebx_individual";

module.exports = Object.freeze({
    // The Google Analytics id for ebx-trial-dev
    // GA_MEASUREMENT_ID: "G-1NB3LZ031D"
    //  We don't need this any more.

    // ---
    // Add app-level constants here.
    // ---
    
    // Org-level properties
    ORG_PROPERTIES: Object.freeze({
        
        // Organisation id for dev team
        DEV_ORG: "_ebx_dev_team",
        
        // Organisations for managing individual users
        INDIVIDUAL_USER_ORG_FULL: `${INDIVIDUAL_USER_ORG_PREFIX}_full`,

        ORG_EXPORT_COMPLETED_GRACE_PERIOD: 'imageExportCompletedGracePeriod',
        ORG_WORKFLOW_COMPLETED_GRACE_PERIOD: 'workflowCompletedGracePeriod',
        ORG_WORKFLOW_STALLED_PERIOD: 'workflowStalledPeriod',
    }),
    
    // Map sector keys to display values - don't change the key without migrating values in Firestore
    ORG_SECTORS: {
        "Environment": "Environment", 
        "Education": "Education",
        "Forestry": "Natural Resource Management",
        "Insurance": "Insurance"
    },
    
    // Map org types to display values - don't change the key without migrating values in Firestore
    ORG_TYPES: {
        "Private Sector - [SME, Startup, Enterprise]": "Private Sector - [SME, Startup, Enterprise]",
        "Federal Government": "Federal Government",
        "Local Government": "Local Government",
        "Charity": "Charity",
        "NGO": "NGO"
    },
    
    // Acceptable roles for LTI integration
    LTI_ROLES: [
        "Learner",
        "Instructor",
        "TeachingAssistant"
    ]    
    
});
